import { runInAction } from "mobx";

import { ChatsStore } from "@/store/ChatsStore";
import { useStore } from "@/store/RootStoreProvider";

export function useChats(): ChatsStore {
  const rootStore = useStore();

  if (!rootStore.chats) {
    runInAction(() => {
      if (!rootStore.chats) {
        rootStore.chats = new ChatsStore(rootStore);
      }
    });
  }

  return rootStore.chats!;
}
